import axios from 'axios'

const rnc = {
  getUserMessages: tag => {
    if (tag === '') {
      return axios.get(
        `${process.env.REACT_APP_API_URL}rnc/Messages`
      ).then( res => res.data)     
    }
    return axios.get(
      `${process.env.REACT_APP_API_URL}rnc/Messages?tag=${tag}`
    ).then( res => res.data)        
  },
  postUserMessage: (data) => axios.post(
    `${process.env.REACT_APP_API_URL}rnc/Message`, data
  ).then( res => res.data),
  putUserMessage: (id, tag) => axios.put(
    `${process.env.REACT_APP_API_URL}rnc/Message?id=${id}&tag=${tag}`
  ).then( res => res.data),
  deleteUserMessage: (id) => axios.delete(
    `${process.env.REACT_APP_API_URL}rnc/Message?id=${id}`
  ).then( res => res.data),
  getMessagesUnread : ()=> axios.get( 
    `${process.env.REACT_APP_API_URL}rnc/MessagesUnread`
  ).then( res => res.data),
  getMessageLinkID: id => {
    return axios.get(
      `${process.env.REACT_APP_API_URL}rnc/MessageLinkID?id=${id}`
    ).then( res => res.data)        
  },
  getFinancialSummary : (advisor)=> axios.get(
    `${process.env.REACT_APP_API_URL}rnc/FinancialSummary?advisor=${advisor?1:0}`
  ).then( res => res.data),
  getFamilyTree : ()=> axios.get(
    `${process.env.REACT_APP_API_URL}rnc/FamilyTree`
  ).then( res => res.data),
  postFamilyTree : (data)=> axios.post(
    `${process.env.REACT_APP_API_URL}rnc/FamilyTree`, data
  ).then( res => res.data),
  updatePhasesBMC: (data) => axios.post(
    `${process.env.REACT_APP_API_URL}rnc/UpdatePhasesBMC`, data
  ).then( res => res.data ),
  getCPPEstimator : ()=> axios.get(
    `${process.env.REACT_APP_API_URL}rnc/CPPEstimator`
  ).then( res => res.data),
  postCPPEstimator : (data)=> axios.post(
    `${process.env.REACT_APP_API_URL}rnc/CPPEstimator`, data
  ).then( res => res.data),
  postCPPEstimate : (data)=> axios.post(
    `${process.env.REACT_APP_API_URL}rnc/CPPEstimate`, data
  ).then( res => res.data),
  getCPPEstimate : ()=> axios.get(
    `${process.env.REACT_APP_API_URL}rnc/CPPEstimate`
  ).then( res => res.data),
  postCPPOptimize : (data, inflation)=> {
    if (inflation || inflation===0) {
      return axios.post(`${process.env.REACT_APP_API_URL}rnc/CPPOptimize?i=${inflation}`, data).then( res => res.data)
    } else {
      return axios.post(`${process.env.REACT_APP_API_URL}rnc/CPPOptimize`, data).then( res => res.data)
    }
  },
  postCPPAccumulate : (data, inflation) => {
    if (inflation || inflation===0) {
      return axios.post(`${process.env.REACT_APP_API_URL}rnc/CPPAccumulate?i=${inflation}`, data).then( res => res.data)
    } else {
      return axios.post(`${process.env.REACT_APP_API_URL}rnc/CPPAccumulate`, data).then( res => res.data)
    }
  }, 
  getLinks : (count, order)=> axios.get(
    `${process.env.REACT_APP_API_URL}rnc/Links?count=${count}&order=${order}`
  ).then( res => res.data),
  getAdvisor : (count, order)=> axios.get(
    `${process.env.REACT_APP_API_URL}rnc/Advisor`
  ).then( res => res.data),
  advisor: {
    postEditProspect: (id) => axios.post(
      `${process.env.REACT_APP_API_URL}rnc/EditProspect?id=${id}`
    ).then( res => res.data),
    getViewProspect: () => axios.get(
      `${process.env.REACT_APP_API_URL}rnc/ViewProspect`
    ).then( res => res.data), 
    getViewProspectData: () => axios.get(
      `${process.env.REACT_APP_API_URL}rnc/ViewProspectData`
    ).then( res => res.data), 
    getProspects: () => axios.get(
      `${process.env.REACT_APP_API_URL}rnc/Prospects`
    ).then( res => res.data), 
    putProspectNote: (id, note) => axios.put(
      `${process.env.REACT_APP_API_URL}rnc/ProspectNote`, {id, note}
    ).then( res => res.data),
    putProspectStatus: (id, status, callDate, reason) => axios.put(
      `${process.env.REACT_APP_API_URL}rnc/ProspectStatus`, {id, status, callDate, reason}
    ).then( res => res.data),
    getAdvisorNotes: (search) => axios.get(
      `${process.env.REACT_APP_API_URL}rnc/Notes${!search ? '' : '?search='+search}`
    ).then( res => res.data),
    postAdvisorNote: (data, send) => axios.post(
      `${process.env.REACT_APP_API_URL}rnc/Note${!send ? '' : '?send='+send}`, data
    ).then( res => res.data),
    deleteAdvisorNote: (id) => axios.delete(
      `${process.env.REACT_APP_API_URL}rnc/Note?id=${id}`
    ).then( res => res.data),
  } 
}
export default rnc